import { HANDS, LOCAL_STORAGE_KEYS } from '@/constants';
import HelperMethods from '@/helpers/HelperMethods';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const setupPersistedSetting = ({ localStorageKey, storeKey, onChange }) => {
  return {
    storeKey,
    value: localStorage.getItem(localStorageKey),
    setter: (state, value) => {
      state[storeKey] = value;

      if (value) {
        localStorage.setItem(localStorageKey, value);
      } else {
        localStorage.removeItem(localStorageKey);
      }

      if (onChange) {
        onChange(state, value);
      }
    },
  };
};

// Persisted settings
const persistedSettings = [
  {
    localStorageKey: LOCAL_STORAGE_KEYS.SUBTITLES_ON,
    storeKey: 'subtitlesOn',
  },
  {
    localStorageKey: LOCAL_STORAGE_KEYS.PLAYBACK_RATE,
    storeKey: 'playbackRate',
  },
  {
    localStorageKey: LOCAL_STORAGE_KEYS.PLAYBACK_RATE_ON,
    storeKey: 'playbackRateOn',
    onChange(state, playbackRateOn) {
      if (!playbackRateOn) {
        state.playbackRate = 1;
        localStorage.removeItem(LOCAL_STORAGE_KEYS.PLAYBACK_RATE);
      }
    },
  },
  {
    localStorageKey: LOCAL_STORAGE_KEYS.REMOTE_CODE_VERIFICATION,
    storeKey: LOCAL_STORAGE_KEYS.REMOTE_CODE_VERIFICATION,
    onChange(state, newVal) {
      if (!newVal) {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.REMOTE_CODE_VERIFICATION);
      }
    },
  },
  {
    localStorageKey: LOCAL_STORAGE_KEYS.DEV_MODE,
    storeKey: 'devModeOn',
    onChange(state, devModeOn) {
      if (!devModeOn) {
        state.playbackRate = 1;
        localStorage.removeItem(LOCAL_STORAGE_KEYS.PLAYBACK_RATE);
        state.playbackRateOn = false;
        localStorage.removeItem(LOCAL_STORAGE_KEYS.PLAYBACK_RATE_ON);
        state[LOCAL_STORAGE_KEYS.REMOTE_CODE_VERIFICATION] = false;
        localStorage.removeItem(LOCAL_STORAGE_KEYS.REMOTE_CODE_VERIFICATION);
      }
    },
  },
].map(setupPersistedSetting);

export default new Vuex.Store({
  state: {
    help: {},
    tutorials: [],
    fullTutorials: {},
    hands: HelperMethods.getJsonFromLocalStorage({
      key: LOCAL_STORAGE_KEYS.HANDS,
    }),
    ...persistedSettings.reduce(
      (acc, s) => ({
        ...acc,
        [s.storeKey]: s.value,
      }),
      {},
    ),
  },
  mutations: {
    setHelp(state, help) {
      state.help = help;
    },
    setTutorials(state, tutorials) {
      state.tutorials = tutorials;
    },
    setTutorial(state, tutorial) {
      state.fullTutorials[tutorial.slug_url] = tutorial;
    },
    setTutorialHand(state, { tutorialId, hand }) {
      state.hands = {
        ...state.hands,
        [tutorialId]: hand || HANDS.RIGHT,
      };

      HelperMethods.setJsonInLocalStorage({
        key: LOCAL_STORAGE_KEYS.HANDS,
        json: state.hands,
      });
    },
    ...persistedSettings.reduce(
      (acc, s) => ({
        ...acc,
        [s.storeKey]: s.setter,
      }),
      {},
    ),
  },
  actions: {},
  modules: {},
});
